import { ChangeDetectorRef, Component, inject } from '@angular/core';

import { combineLatest, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  ButtonComponent,
  EmptyStateComponent,
  HeadingComponent,
  IconComponent,
  SpinnerComponent,
} from '@core/user-interface-legacy';
import type { AssignedJob } from '@recruitee/requisitions-data';

import { RequisitionsJobsListContainerComponent } from '../../../containers/single-requisition/requisitions-jobs-list-container/requisitions-jobs-list-container.component';
import { JobsPageDataService } from '../../../data/single-requisition/jobs-page-data.service';
import { CreateJobFacade } from '../../../facades/single-requisition/create-job.facade';
import { RequisitionsSharedActionsService } from '../../../services/requisitions-shared-actions.service';

@Component({
  selector: 'rt-requisitions-jobs-page',
  templateUrl: './jobs-page.component.html',
  styleUrls: ['./jobs-page.component.less'],
  imports: [
    ButtonComponent,
    EmptyStateComponent,
    HeadingComponent,
    IconComponent,
    RequisitionsJobsListContainerComponent,
    SpinnerComponent,
    TranslatePipe,
  ],
  providers: [JobsPageDataService],
})
export class JobsPageComponent {
  private readonly createJobFacade = inject(CreateJobFacade);
  private readonly requisitionsSharedActionsService = inject(RequisitionsSharedActionsService);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly data = inject(JobsPageDataService);

  public jobs: AssignedJob[] = [];
  public isLoaded = false;
  public emptyStateVariant: 'not_approved' | 'no_jobs';
  public hasCreateJob = false;
  public requisitionId: number;
  private ngOnDestroy$ = new Subject<void>();

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public ngOnInit() {
    combineLatest([
      this.data.jobs$.pipe(tap(jobs => (this.jobs = jobs))),
      this.data.isLoaded$.pipe(tap(isLoaded => (this.isLoaded = isLoaded))),
      this.data.requisition$.pipe(tap(requisition => (this.requisitionId = requisition.id))),
    ]).subscribe(() => {
      if (this.isLoaded) {
        this.cdRef.detectChanges();
      }
    });

    this.hasCreateJob = this.createJobFacade.canCreateJob;
    this.emptyStateVariant = this.createJobFacade.isAssigningJobsAllowed
      ? 'no_jobs'
      : 'not_approved';
  }

  public createJob(): void {
    this.requisitionsSharedActionsService.createJob(this.requisitionId);
  }
}
